import { Box } from "@mui/material";
import PicturesAndText2 from "./PicturesAndText2";
// import TreeWithLogos from "./TreeWithLogos";
import ExpertsInSoccerAndEducation from './ExpertsInSoccerAndEducation'
import Achievements from "../../achievements/Achievements";
import CallToAction from "../../call_to_action/CallToAction";
import Header from "./Header";

const About = () => {
  return (
    <Box sx={{ backgroundColor: 'white' }}>
      <Header/>
      <PicturesAndText2 />
      <Achievements/>
      <ExpertsInSoccerAndEducation/>
      {/* <TreeWithLogos/> */}
      <CallToAction/>
    </Box>
  );
};

export default About;

